module.exports = __webpack_public_path__ + "static/img/5.8c94c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/5.jpg
// module id = 0cpB
// module chunks = 29